import { ControllerAdditionalInfo } from 'src/types/controllers/controller';
import { LabelingTypeEnum } from 'src/types';
import { PREDEFINED, RANGE } from '../config';

type UseModePossibleValuesTypes = {
  data: ControllerAdditionalInfo[];
};

type PossibleValues = {
  id?: string;
  displayName: string;
  value?: string;
  // Labelling metadata of the mode tag the option originates from, so the dropdown
  // can re-render the option while `displayName` stays canonical for the submit parser.
  name?: string;
  tagDisplayName?: string;
  labellingType?: LabelingTypeEnum;
  fallbackValue?: string;
  isPredefined?: boolean;
};

export const modePossibleValues = ({ data }: UseModePossibleValuesTypes) => {
  const possibleValues: PossibleValues[] = [];
  const isMultipleModeTags = data?.length > 1;

  const isControllableModeTag = data?.every((item) => item.advancedTagMapping.controllable);

  data?.forEach((tag) => {
    const allowedInputs = tag?.advancedTagMapping?.allowedInputs;

    if (!isMultipleModeTags && allowedInputs === PREDEFINED) {
      tag.advancedTagMapping?.userDefinedValues?.forEach(({ tagId, value, name }: any) => {
        const tagForDisplay = {
          id: tagId,
          displayName: `${value}-${name}`,
          value: value.toString(),
          name,
          labellingType: tag?.labellingType,
          fallbackValue: tag?.fallbackValue,
          isPredefined: true,
        };
        possibleValues.push(tagForDisplay);
      });
    }

    if (isMultipleModeTags && allowedInputs === RANGE) {
      const { displayName } = tag;
      const maximumValue = tag.advancedTagMapping?.maximumValue;
      const minimumValue = tag.advancedTagMapping?.minimumValue;
      if (!maximumValue || (!minimumValue && minimumValue !== 0)) return;
      for (let i = minimumValue; i < maximumValue + 1; i++) {
        const tagForDisplay = {
          id: tag.id,
          displayName: `${displayName}-${i.toString()}`,
          value: i.toString(),
        };
        possibleValues.push(tagForDisplay);
      }
    }

    if (isMultipleModeTags && allowedInputs === PREDEFINED) {
      const { displayName } = tag;
      tag.advancedTagMapping?.userDefinedValues?.forEach(({ tagId, value, name }: any) => {
        const tagForDisplay = {
          id: tagId,
          displayName: `${displayName}-${value}-${name}`,
          value: value.toString(),
          name,
          tagDisplayName: displayName,
          labellingType: tag?.labellingType,
          fallbackValue: tag?.fallbackValue,
          isPredefined: true,
        };
        possibleValues.push(tagForDisplay);
      });
    }

    if (!isMultipleModeTags && allowedInputs === RANGE) {
      const maximumValue = tag.advancedTagMapping?.maximumValue;
      const minimumValue = tag.advancedTagMapping?.minimumValue;
      if (!maximumValue || (!minimumValue && minimumValue !== 0)) return;
      for (let i = minimumValue; i < maximumValue + 1; i++) {
        const tagForDisplay = {
          id: tag.id,
          displayName: i.toString(),
          value: i.toString(),
        };
        possibleValues.push(tagForDisplay);
      }
    }
  });

  return { possibleValues, isControllableModeTag };
};
